<template>
  <div class="detailBox">
    <div class="optionItem boxStyle" >
      <van-cell-group>
      <h3 >预约信息-{{ detailInfo.guestOrderNo }}</h3>
      <van-cell title="校区" is-link :value="detailInfo.zoneName" />
      <van-cell title="姓名" is-link :value="detailInfo.name" />
      <van-cell title="证件号码" is-link :value="detailInfo.idcard" />
      <van-cell title="联系方式" is-link :value="detailInfo.phone" />
      <van-cell title="车牌号码" is-link :value="detailInfo.plate" />
      <van-cell title="登记时间" is-link :value="detailInfo.applyTime" />
      <van-cell title="预约时间" is-link :value=" (timeFilter(detailInfo.beginTime) ||'') + '~' + (timeFilter(detailInfo.endTime) ||'')" ></van-cell>
      <!-- <van-cell title="结束时间" is-link :value="detailInfo.endTime"  /> -->
      <van-cell title="预约结果" is-link   >
        <van-tag type="primary" size="large" v-if="detailInfo.status == 0">审批中</van-tag>
        <van-tag type="success" size="large" v-if="detailInfo.status == 1">预约成功</van-tag>
        <van-tag type="danger" size="large" v-if="detailInfo.status == -1">预约失败</van-tag>
      </van-cell>
      <van-cell title="原因" is-link v-if="detailInfo.status == -1"  :value="reason || '暂无原因'" />
      <!-- <van-cell title="登记时间"  is-link value="2023-03-18 08:56:23"  /> -->
      <!-- <van-cell title="结束时间" is-link :value="detailInfo.endTime" v-if="detailInfo.baseOrderType != 4"  /> -->
     </van-cell-group>
    </div>
    <div v-if="detailInfo.guestList && detailInfo.guestList.length > 0">
      <div v-for="(item, i) in detailInfo.guestList" :key="item.guestOrderUserId"  class="optionItem boxStyle" style="margin-bottom: 20px">
        <van-cell-group  >
          <h3 >同行人{{ i + 1 }}</h3>
          <van-cell title="姓名" is-link :value="item.name" />
          <van-cell title="证件号码"  is-link :value="item.idcard"  />
          <van-cell title="联系方式"  is-link :value="item.phone"  />
          <van-cell title="车牌号码"  is-link :value="item.plate"  />
          
        </van-cell-group>

      </div>
    </div>
     
    
  </div>
</template>

<script>
const Dayjs = require("dayjs");
import { getGuestOrderDetail } from '@/api/user'
export default {
  data () {
    return {
      verifyList: [],
      verifyShowStatus: true,
      freeStatus: false,
      detailInfo: {},
      verifyPopupStatus: false,
      info: {},
      confirmLoading: false,
      guestUserInfo: {}
    }
  },
  created () {
    console.log(this.$route.query);
    this.getGuestOrderDetail(this.$route.query.id)
    
  },
  methods: {
    timeFilter (val) {
      if (val) {
        return Dayjs(val).format('YYYY/MM/DD')
      }
    },
    // 获取详情
    getGuestOrderDetail (id) {
      getGuestOrderDetail({guestOrderId: id}).then(res => {
        if(res.code === 0) {
          this.detailInfo = res.data || {}
          
          let detail = {...res.data}
          if (res.data.guestList && res.data.guestList.length) {
            res.data.guestList.forEach(item => {
              if (item.master == 1) {

                detail = { ...item, ...detail}
              }
            })
          }
          detail.guestList = res.data.guestList.filter(item => item.master != 1)
          this.detailInfo = {...detail}
        }else{
        this.$toast.fail(res.msg)
        }
      }).catch(err => {
        console.error(err);
        this.$toast('获取详情失败:请求失败')
      })
    }
  }
}
</script>

<style scoped lang="less">

.detailBox {
  height: 100vh;
  overflow-y: auto;
  background-color: #fcfffc;
  padding: 10px;
}
.boxStyle {
  
  border-radius: 8px;
  box-shadow: 0 0 13px 4px rgba(156, 156, 156, 0.223);
}
.optionItem {
  background-color: #fff;
  overflow: hidden;
  margin-top: 15px;
  // padding-top: 10px;
  h3 {
    // font-size: 15px;
    padding: 8px
  }
  
}
</style>